import { urlAfip, urlClient } from '@/helpers';
import { httpInstance } from '@/clients/http.request';

export const consultarCliente = async (
   { state, rootState, commit },
   { tipoDocumento, numeroDocumento },
) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAfip}/${tipoDocumento}/${numeroDocumento}`,
      );
      commit('setCliente', data.cliente);
      rootState.poliza.poliza.id_provincia = data?.poliza?.id_provincia;
      rootState.poliza.poliza.id_localidad = data?.poliza?.id_localidad;
      commit('updateCli', {
         key: 'id_localidad',
         value: data?.poliza?.id_localidad,
      });
      return data;
   } catch (error) {
      if (error.response.status === 404 || error.response.status === 503) {
         commit('setCliente', error.response.data);
         throw error;
      }
      throw error;
   }
};

export const consultarReferente = async (
   { commit },
   { tipoDocumento, numeroDocumento },
) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAfip}/${tipoDocumento}/${numeroDocumento}`,
      );
      commit('setReferente', data?.cliente);
      return data;
   } catch (error) {
      throw error;
   }
};

export const getTipoPersona = async ({ commit }) => {
   try {
      const { data } = await httpInstance.get(`${urlClient}/tipoPersona`);
      commit('automotor/setTipoPersona', data, { root: true });
      return data;
   } catch (error) {
      throw error;
   }
};
